const infoAcc = par => {
    if (document.querySelector(`${par}`)) {
        let parent = document.querySelector(`${par}`)
        let labels = parent.querySelectorAll('label')
        labels.forEach((label, id) => {
            let check = true
            let input = label.querySelector('input')
            let target = parent.querySelector('[data-target]')
            // input.setAttribute('name', label.querySelector('.Checkbox__text').textContent)

            label.onmousedown = () => {

                if (!label.hasAttribute('data-target')) {
                    if (target.hasAttribute('checked')) {
                        target.removeAttribute('checked')
                        target.querySelector('input').checked = false
                    }
                    input.checked ? input.checked = check : input.checked = !check
                    label.toggleAttribute('checked')
                } else {
                    input.checked ? input.checked = check : input.checked = !check
                    label.toggleAttribute('checked')

                    labels.forEach((el, index) => {
                        let input = el.querySelector('input')
                        if (id !== index) {
                            el.removeAttribute('checked')
                            input.checked = false
                        }
                    })
                }

                // if (label.hasAttribute('data-target')) {

                // }
            }
        })
    }
}

const infoAccApi = (par, btn) => {
    let checkbox = par.querySelectorAll('input')
    if (par.querySelector('[checked]')) {
        let body = {
            retail: checkbox[0].checked ? 'Y' : 'N',
            noPrise: checkbox[1].checked ? 'Y' : 'N',
            opt: checkbox[2].checked ? 'Y' : 'N',
        }
        $.ajax({
            url: `${par.getAttribute('data-action')}`,
            method: 'post',
            dataType: 'json',
            data: body,
            success: response => {
                if (response.status === 'success') {
                    btn.setAttribute('href', response.link);
                    btn.setAttribute('download', '');
                    btn.removeAttribute('onclick')
                    btn.click();
                }
            },
            error: () => {
                console.log(body)
            }
        })
    }
}

infoAcc('.information-account__content')